/** First whitespace-separated token of a full name, for compact display. Storage keeps the full name. */
// ponytail: plain first token; add last-name initial on collision if two workers share a first name
export const firstName = (name: string | undefined | null): string =>
  (name ?? '').trim().split(/\s+/)[0] ?? '';

/** Hebrew time-of-day greeting: 05–11 בוקר, 12–16 צהריים, 17–21 ערב, else לילה. */
export function timeGreeting(hour: number = new Date().getHours()): string {
  if (hour >= 5 && hour < 12) return 'בוקר טוב';
  if (hour >= 12 && hour < 17) return 'צהריים טובים';
  if (hour >= 17 && hour < 22) return 'ערב טוב';
  return 'לילה טוב';
}
